<p-table
    #tableRef
    [columns]="relevantColumns"
    [hidden]="hidden"
    [loading]="loading"
    [pageLinks]="pageLinks"
    [paginator]="paginator"
    [rows]="internalRowCount"
    [scrollable]="scrollable"
    [scrollHeight]="scrollHeight"
    [selectionMode]="selectionMode"
    [styleClass]="styleClass"
    [value]="data"
    (onPage)="onPage($event)"
    (onRowSelect)="onRowSelect($event)"
    (onRowUnselect)="onRowDeselect($event)"
    dataKey="id"
    sortField="code"
>
    <ng-template pTemplate="emptymessage">
        @if (!loading && emptyMessage) {
            <tr>
                <td
                    class="m-table-empty-message"
                    [attr.colspan]="relevantColumns.length"
                >
                    {{ "table.empty" | translate }}
                </td>
            </tr>
        }
    </ng-template>

    <ng-template pTemplate="paginatorleft">
        @if (total) {
            {{ "table.total" | translate }}: {{ total }}
        }
    </ng-template>

    @if (footer && !paginator) {
        <ng-template pTemplate="summary">
            @if (total) {
                {{ "table.total" | translate }}: {{ total }}
            }
        </ng-template>
    }

    @if (headers) {
        <ng-template pTemplate="header">
            <tr>
                @for (column of relevantColumns; track columnTrackByFn($index, column)) {
                    <th
                        [ngStyle]="column.ngStyle"
                        [pSortableColumn]="column.field"
                        [pSortableColumnDisabled]="!sortable || !column.sortable"
                    >
                        <div class="m-column-header">
                            <div class="m-column-header-wrapper">
                                <span class="m-column-title">
                                    {{ column.header | translate }}
                                </span>
                                @if (sortable && column.sortable) {
                                    <p-sortIcon [field]="column.field"> </p-sortIcon>
                                }
                                @if (filter) {
                                    <app-table-filter
                                        class="m-column-filter"
                                        [column]="column"
                                        [table]="table"
                                    >
                                    </app-table-filter>
                                }
                            </div>
                            <app-table-filter-preview [column]="column"></app-table-filter-preview>
                        </div>
                    </th>
                }
            </tr>
        </ng-template>
    }

    <ng-template
        [appTableRow]="data"
        let-device
        let-index="rowIndex"
        pTemplate="body"
    >
        <tr
            [pReorderableRow]="index"
            [pSelectableRow]="device"
        >
            @for (column of relevantColumns; track columnTrackByFn($index, column)) {
                <td [ngStyle]="column.ngStyle">
                    @switch (column.field) {
                        @case ("reorder") {
                            <div
                                class="flex justify-center"
                                style="width: 100%"
                            >
                                <i
                                    class="fa fa-bars"
                                    pReorderableRowHandle
                                ></i>
                            </div>
                        }
                        @case ("commands") {
                            <div
                                class="m-btn-group"
                                style="margin-top: 0"
                            >
                                @for (command of relevantCommands; track commandTrackByFn($index, command)) {
                                    @if (command.rowValidFunc(device)) {
                                        <app-icon-button
                                            [disabled]="command.disabledFunc()"
                                            [icon]="command.icon"
                                            [text]="command.text"
                                            (click)="command.click(device)"
                                        />
                                    }
                                }
                            </div>
                        }
                        @default {
                            {{ device[column.field] }}
                        }
                    }
                </td>
            }
        </tr>
    </ng-template>
</p-table>
